/**
 * @file     MoreDetail.tsx
 * @purpose  The "More detail" disclosure in the family 7 tool inputs: the
 *           secondary inputs stay mounted and collapse behind one toggle.
 */
'use client';

import { useId, useState } from 'react';
import Box from '@mui/material/Box';
import { focusRingSx, hairline, hubColors, hubRadius } from '@/components/hub/hubKitStyles';

export function MoreDetail({ label, children, defaultOpen = false }: { label: string; children: React.ReactNode; defaultOpen?: boolean }) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();
  return (
    <Box sx={{ borderTop: hairline, pt: 1 }}>
      <Box
        component="button"
        type="button"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((value) => !value)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          minHeight: 44,
          p: 0,
          border: 0,
          borderRadius: `${hubRadius.control}px`,
          background: 'none',
          font: 'inherit',
          fontSize: 15,
          fontWeight: 500,
          color: hubColors.textPrimary,
          cursor: 'pointer',
          ...focusRingSx,
        }}
      >
        {label}
        <Box component="span" aria-hidden="true" sx={{ fontSize: 20, lineHeight: 1, color: hubColors.textSecondary }}>
          {open ? '−' : '+'}
        </Box>
      </Box>
      <Box id={panelId} hidden={!open} sx={{ pt: 2, display: open ? 'flex' : 'none', flexDirection: 'column', gap: 3 }}>
        {children}
      </Box>
    </Box>
  );
}
